import axios from 'axios';
import moment from "moment";
import { utilityService } from '@/services/utilityService.js';
import { dateService } from '@/services/date.service.js';

export const clientEventService = {

	// Returns the client events
	getClientEvents,
	getClientEventsReport,
	notifyClientEventsReport
};

/**
 * Returns client events based on the criteria specified
 * @param {*} criteria 
 * @returns 
 */
function getClientEvents(criteria) {

	return axios.get(utilityService.buildFullyQualifiedUrl(`event/find?studyCode=${criteria.study}&staffId=${criteria.staffId}&timeStampStart=${criteria.dateStart}&timeStampEnd=${criteria.dateEnd}&severity=WARN,FATAL`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

function getClientEventsReport(criteria) {

	let path = `event/report?studyCode=${criteria.study}&start=${criteria.timeStampStart}&end=${criteria.timeStampEnd}`;
	if (criteria.staffId && criteria.staffId !== 'ALLSTAFF') {
		path += `&staffId=${encodeURIComponent(criteria.staffId)}`;
	}

	return axios.get(utilityService.buildFullyQualifiedUrl(path),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

function notifyClientEventsReport(criteria, eventReport) {
	return axios.post(utilityService.buildFullyQualifiedUrl(`staff/notify?studyCode=${criteria.study}&staffId=${criteria.staffId}`),
		eventReport,
		{
			headers: utilityService.getHeaders()
		}
	);
}